export default __webpack_public_path__ + "static/media/cheers.ab0ce255.svg";